import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import behavior from './modules/behavior'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accessToken: '',
    user: {},
    // 输入记录
    record: {},
    // 配置信息
    brand: {},
    // 申请输入内容
    apply: {},
    // 银行卡列表
    bankCard: [],
    // 上笔订单信息
    queryStatus: {},
    // 是否确认服务协议
    checkedServiceAgreement: false,
    // 从其他机构来的快捷申请
    fromOther: 'N',
  },
  mutations: {
    SET_RECORD_ITEM(state, item) {
      state.record[item.key] = item.value
    },
    SET_APPLY_ITEM(state, item) {
      state.apply[item.key] = item.value
    },
    SET_ACCESS_TOKEN(state, val) {
      state.accessToken = val
    },
    SET_USER(state, val) {
      state.user = val
    },
    SET_BRAND(state, val) {
      state.brand = val
    },
    SET_BANK_CARD(state, val) {
      state.bankCard = val
    },
    SET_QUERY_STATUS(state, val) {
      state.queryStatus = val
    },
    SET_CHECKED_SERVICE_AGREEMENT(state, val) {
      state.checkedServiceAgreement = val
    },
    SET_FROM_OTHER(state, val) {
      state.fromOther = val
    }
  },
  actions: {
  },
  modules: {
    behavior,
  },
  plugins: [createPersistedState({
    storage: window.localStorage,
    reducer(val) {
      return {
        accessToken: val.accessToken,
        user: val.user,
        fromOther: val.fromOther,
        brand: val.brand,
        checkedServiceAgreement: val.checkedServiceAgreement,
      }
    }
  }), createPersistedState({
    storage: window.sessionStorage,
    reducer(val) {
      return {
        record: val.record,
        apply: val.apply,
        behavior: val.behavior,
        bankCard: val.bankCard,
        queryStatus: val.queryStatus,
      }
    }
  })]
})
